import { MobileContentFrameWindow } from './types';

export const getScreenHeight = (window: MobileContentFrameWindow): number => {
  return window.innerHeight;
};
